const REGISTRATION_URL = "https://events.zoom.us/ev/Av9gTeruflzyzt9Y6pxedKszdlKWnnlhCCdstAih7dBjnkyQ684u~Att_siRftqozydHUmCJ9ibyhHYfd87bGo8buB1vDrX9HkU_-eaYmAiF7Nw";
const HUB_URL = "https://events.zoom.us/eo/AlmCmVZpswTgNBq3kaf1LpR09suPl8dSam3rcZxZMzRWGS7PZOwI~AggLXsr32QYFjq8BlYLZ5I06Dg";

export default function WebinarCard() {
  return (
    <div className="p-2 rounded-lg border-solid border border-green-600">
      <img
        src="/locker-room-banner.jpeg"
        alt="The Locker Room — Weekly Training for Teams and Leaders, Every Wednesday 10 AM MT, Free"
        className="w-full rounded-lg"
      />

      <div className="mt-4 px-2">
        <p className="text-md font-semibold leading-6 text-gray-900">
          All of our live training and the recordings of these live trainings
          will be available through Zoom Events through the Locker Room Training
          for Teams and Leaders.
        </p>

        <a
          href={REGISTRATION_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block mt-3 w-full px-4 py-2 text-white bg-green-600 rounded-lg text-center font-medium hover:bg-green-700"
        >
          View Schedule &amp; Register
        </a>
      </div>

      <hr className="my-4 border-gray-200" />

      <div className="px-2 pb-2">
        <p className="text-sm leading-5 text-gray-600">
          If you'd like to view past live trainings, you can view them through
          our hub as they become available.
        </p>
        <a
          href={HUB_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-2 text-sm font-medium text-green-700 underline hover:text-green-800"
        >
          View Past Trainings Hub
        </a>
      </div>
    </div>
  );
}
